import './GPCAccountAndFundAlerts.scss';

import { bool, func } from 'prop-types';
import { isNil } from 'lodash';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import FundSelectionModal from 'components/layouts/Preferences/Subscriptions/FundSelectionModal';
import Content from 'services/Content';

import {
  ALL_FUNDS_SUBSCRIPTION_TYPE_ID,
  MY_FUNDS_SUBSCRIPTION_TYPE_ID,
  SELECTED_FUNDS_SUBSCRIPTION_TYPE_ID
} from 'services/Preferences';

import { hasOwnedMutualFunds } from 'state/view/ViewSelectors';
import { getHasInvalidOrNoEmailAddress } from 'state/contactMethodMaintenance/ContactMethodMaintenanceSelectors';
import {
  getAllFundDailyPrices,
  getIsSubscribedToMarketWrapUps,
  getIsSubscribedToTaxForms,
  getMonthlyPriceFunds,
  getMyFundsDailyPrices,
  getMyMonthlyFundPerformances,
  getSelectDailyFundPrices,
  getSelectMonthlyFundPrices,
  getAllMonthlyFundPrices,
  getDailyFundPricesSelected,
  getPerformanceFundPricesSelected,
  getSelectedDailyFunds
} from 'state/subscriptions/SubscriptionsSelectors';
import GPCSubscriptionsRowLabel from './shared/GPCSubscriptionsRowLabel';
import { getHasOwnedCollegeSavingsOnly } from 'state/account/AccountSelectors';
import { ReactComponent as QuestionCircle } from 'assets/icons/question-circle.svg';
import DisclosureModal from 'components/shared/DisclosureModal/DisclosureModal';
import {
  AAMBeaconControl,
  AAMBeaconControlGroup
} from 'components/shared/Beacon';

const MonthlyFundPerformancesRow = ({
  monthlyFundPerformancesSelected,
  handleChange,
  hasInvalidOrMissingEmail,
}) => {

  return (
    <div className="GPC-account-and-fund-alerts-with-secondary-container">
      <div className="GPC-account-and-fund-alerts-checkbox-container-secondary">
        <AAMBeaconControl inline>
          <div slot="label"
               className="GPC-account-and-fund-alerts-checkbox">
            <label htmlFor="monthlyFundPerformancesSelected">
              T. Rowe Price Monthly Fund Performance
            </label>
            <DisclosureModal icon={<QuestionCircle slot={'suffix'} />}
                             closeOnClickOut>
              <Fragment>
                <div className="b-typography-serif--headline--200">T. Rowe Price Monthly Fund Performance</div>
                <div className="b-typography-sans-serif--body--200 b-font-weight-light">{Content.subscriptionsTrpMonthlyFundPerformances}</div>
              </Fragment>
            </DisclosureModal>
          </div>
          <input type="checkbox"
                 id="monthlyFundPerformancesSelected"
                 checked={monthlyFundPerformancesSelected}
                 disabled={hasInvalidOrMissingEmail}
                 onChange={(e) => handleChange(e.target.id, e.target.checked)} />
        </AAMBeaconControl>
      </div>
    </div>
  );
};

const DailyFundPricesRow = ({
  allFundDailyPrices,
  dailyFundPricesSelected,
  handleChange,
  hasInvalidOrMissingEmail,
  hasMutualFunds,
  myFundsDailyPrices,
  selectDailyFundPrices,
  showModal
}) => {

  const handleRadioChange = event => {
    if(event && event.target) {
      handleChange('myFundsDailyPrices', parseInt(event.target.value));
    }
  };

  return (
    <div className="GPC-account-and-fund-alerts-with-secondary-container">
        <div className="GPC-account-and-fund-alerts-checkbox-container-secondary">
          <AAMBeaconControl inline>
            <div slot="label" className="GPC-account-and-fund-alerts-checkbox">
              <label htmlFor="dailyFundPricesSelected">
                T. Rowe Price Daily Fund Prices
              </label>
              <DisclosureModal icon={<QuestionCircle slot={'suffix'} />}
                               closeOnClickOut>
                <Fragment>
                  <div className="b-typography-serif--headline--200">T. Rowe Price Daily Fund Prices</div>
                  <div className="b-typography-sans-serif--body--200 b-font-weight-light">{Content.subscriptionsTrpDailyFundPrices}</div>
                </Fragment>
              </DisclosureModal>
            </div>
            <input type="checkbox"
                   id="dailyFundPricesSelected"
                   checked={dailyFundPricesSelected}
                   disabled={hasInvalidOrMissingEmail}
                   onChange={(e) => handleChange(e.target.id, e.target.checked)}
            />
          </AAMBeaconControl>
        </div>
        {dailyFundPricesSelected &&
          <div className="GPC-account-and-fund-alerts-secondary-container">
            <AAMBeaconControlGroup>
              {hasMutualFunds &&
                <AAMBeaconControl inline>
                  <label htmlFor={MY_FUNDS_SUBSCRIPTION_TYPE_ID}
                         slot="label">
                    My Mutual Funds
                  </label>
                  <input type="radio"
                         disabled={hasInvalidOrMissingEmail}
                         value={MY_FUNDS_SUBSCRIPTION_TYPE_ID}
                         id={MY_FUNDS_SUBSCRIPTION_TYPE_ID}
                         checked={myFundsDailyPrices}
                         onChange={handleRadioChange} />
                </AAMBeaconControl>
              }
              <AAMBeaconControl inline>
                <label htmlFor={ALL_FUNDS_SUBSCRIPTION_TYPE_ID}
                       slot="label">
                  All Mutual Funds
                </label>
                <input type="radio"
                       disabled={hasInvalidOrMissingEmail}
                       value={ALL_FUNDS_SUBSCRIPTION_TYPE_ID}
                       id={ALL_FUNDS_SUBSCRIPTION_TYPE_ID}
                       checked={allFundDailyPrices}
                       onChange={handleRadioChange} />
              </AAMBeaconControl>
              <AAMBeaconControl inline>
                <label htmlFor={SELECTED_FUNDS_SUBSCRIPTION_TYPE_ID}
                       slot="label">
                  Selected Mutual Funds
                </label>
                <input type="radio"
                       disabled={hasInvalidOrMissingEmail}
                       value={SELECTED_FUNDS_SUBSCRIPTION_TYPE_ID}
                       id={SELECTED_FUNDS_SUBSCRIPTION_TYPE_ID}
                       checked={selectDailyFundPrices}
                       onChange={handleRadioChange} />
              </AAMBeaconControl>
            </AAMBeaconControlGroup>
            {selectDailyFundPrices && (
              <button
                className="GPC-edit-selections"
                onClick={showModal('showDailyFundsModal')}>
                  Edit Selections
              </button>
            )}
          </div>
        }
    </div>
  );
};

//TODO: Move this to a functional component using hooks
class GPCAccountAndFundAlerts extends React.Component {
  state = {
    showDailyFundsModal: false,
    showMonthlyFundsModal: false
  };

  hideModal = (modalName) => () => this.setState({ [modalName]: false });

  showModal = (modalName) => () => this.setState({ [modalName]: true });

  handleChange = (key, value) => {
    const { providedOnChange } = this.props;
    if (!isNil(value)) {
      providedOnChange(key, value);
    } else {
      providedOnChange(key, value);
    }
  };

  onDone = (field) => (fundSelection) => {
    const { providedOnChange } = this.props;
    providedOnChange(field, fundSelection);
  };

  render() {
    const {
      hasInvalidOrMissingEmail,
      subscriptions,
      selectDailyFundPrices,
      monthlyPriceFunds,
      selectMonthlyFundPrices,
      myFundsDailyPrices,
      allFundDailyPrices,
      myMonthlyPerformancePrices,
      allMonthlyPerformancePrices,
      dailyFundPricesSelected,
      monthlyFundPerformancesSelected,
      selectDailyFunds,
      hasOwnedCollegeSavingsOnly,
      hasMutualFunds
    } = this.props;

    const { showDailyFundsModal, showMonthlyFundsModal } = this.state;

    return (
      <Fragment>
      {!hasOwnedCollegeSavingsOnly &&(  
      <div className="GPC-account-and-fund-alerts beacon-on-light">
        {showDailyFundsModal && (
          <FundSelectionModal
            fundsSelected={selectDailyFunds}
            onClose={this.hideModal('showDailyFundsModal')}
            onDone={this.onDone('dailyFundPricesSelected')}
            subscriptions={subscriptions}
            title="Daily Fund Price Alerts: Select Funds"
          />
        )}
        {showMonthlyFundsModal && (
          <FundSelectionModal
            fundsSelected={monthlyPriceFunds}
            onClose={this.hideModal('showMonthlyFundsModal')}
            onDone={this.onDone('monthlyFundPerformancesSelected')}
            subscriptions={subscriptions}
            title="Monthly Fund Performance Alerts: Select Funds"
          />
        )}
        <div className="GPC-additional-notifications-header">Account & Investment Alerts</div>
        <GPCSubscriptionsRowLabel
          label="Subscribed"
          labelClassname="GPC-accounts-and-fund-alerts-header"
        />
        <div className="GPC-subscribed-forms">
            <Fragment>
              {!hasOwnedCollegeSavingsOnly && (
                <Fragment>
                  <div className="GPC-subscribed-row-forms">
                    <DailyFundPricesRow
                      allFundDailyPrices={allFundDailyPrices}
                      dailyFundPricesSelected={dailyFundPricesSelected}
                      handleChange={this.handleChange}
                      hasInvalidOrMissingEmail={hasInvalidOrMissingEmail}
                      hasMutualFunds={hasMutualFunds}
                      myFundsDailyPrices={myFundsDailyPrices}
                      selectDailyFundPrices={selectDailyFundPrices}
                      showModal={this.showModal}
                    />
                    <MonthlyFundPerformancesRow
                      allMonthlyPerformancePrices={allMonthlyPerformancePrices}
                      handleChange={this.handleChange}
                      monthlyFundPerformancesSelected={
                        monthlyFundPerformancesSelected
                      }
                      myMonthlyPerformancePrices={myMonthlyPerformancePrices}
                      hasInvalidOrMissingEmail={hasInvalidOrMissingEmail}
                      hasMutualFunds={hasMutualFunds}
                      selectMonthlyFundPrices={selectMonthlyFundPrices}
                      showModal={this.showModal}
                    />
                  </div>
                </Fragment>
              )}
            </Fragment>
        </div>
      </div>)}
      </Fragment>
    );
  }
}

GPCAccountAndFundAlerts.propTypes = {
  hasOwnedCollegeSavingsOnly: bool.isRequired,
  providedOnChange: func.isRequired,
  onFundSelectionChange: func.isRequired,
  hasInvalidOrMissingEmail: bool.isRequired
};

GPCAccountAndFundAlerts.defaultProps = {
  hasMultipleOwnedCollegeSavings: false,
  hasInvalidOrMissingEmail: false
};

const mapStateToProps = (state) => ({
  hasOwnedCollegeSavingsOnly: getHasOwnedCollegeSavingsOnly(state),
  hasInvalidOrMissingEmail: getHasInvalidOrNoEmailAddress(state),
  isSubscribedToTaxForms: getIsSubscribedToTaxForms(state),
  isSubscribedToMarketWrapUps: getIsSubscribedToMarketWrapUps(state),
  selectDailyFundPrices: getSelectDailyFundPrices(state),
  monthlyPriceFunds: getMonthlyPriceFunds(state),
  myFundsDailyPrices: getMyFundsDailyPrices(state),
  allFundDailyPrices: getAllFundDailyPrices(state),
  myMonthlyPerformancePrices: getMyMonthlyFundPerformances(state),
  selectMonthlyFundPrices: getSelectMonthlyFundPrices(state),
  allMonthlyPerformancePrices: getAllMonthlyFundPrices(state),
  dailyFundPricesSelected: getDailyFundPricesSelected(state),
  monthlyFundPerformancesSelected: getPerformanceFundPricesSelected(state),
  selectDailyFunds: getSelectedDailyFunds(state),
  hasMutualFunds: hasOwnedMutualFunds(state)
});

export default connect(mapStateToProps)(GPCAccountAndFundAlerts);
